import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Endpoints } from '../../core/api/endpoints';
import { environment } from '../../environments/environment';
import { VaccineResponse } from '../models/vaccine-response';

@Injectable({
  providedIn: 'root'
})
export class VaccineService {
  private readonly baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  getAllVaccines(): Observable<VaccineResponse[]> {
    return this.http.get<VaccineResponse[]>(
      `${this.baseUrl}/${Endpoints.vaccine.base}`
    );
  }

  getVaccineById(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/${Endpoints.vaccine.base}/${Endpoints.vaccine.getById(id)}`
    );
  }

  createVaccine(vaccine: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/${Endpoints.vaccine.base}`, vaccine);
  }

  updateVaccine(id: number, vaccine: any): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/${Endpoints.vaccine.base}/${Endpoints.vaccine.update(id)}`, vaccine);
  }
}
